var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flex-column contact p4"},[_c('Logo'),_c('span',{staticClass:"contact__phone binct-phone-number-1"},[_vm._v(_vm._s(_vm.phone))]),_c('span',{staticClass:"contact__mail"},[_vm._v(_vm._s(_vm.mail))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }